import { render, staticRenderFns } from "./NewCampaignModal.vue?vue&type=template&id=8ca9dcac&scoped=true&"
import script from "./NewCampaignModal.vue?vue&type=script&lang=ts&"
export * from "./NewCampaignModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewCampaignModal.vue?vue&type=style&index=0&id=8ca9dcac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9dcac",
  null
  
)

export default component.exports